<template>
  <BLayoutView
    :back-route="backRoute"
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"

    :saveable="saveable"
    :save-menu-list="!!viewTypeOptions.isCreate ? saveMenuList : null"

    @save-menu="onSave"
  >
    <template #form>
      <ComponentForm
        ref="form"
        v-bind="viewTypeOptions"
        :data="data"
        :loading="isLoading"
        :skeleton="isLoadingAsyncData"
        class="my-4"
        @save="onSave"
        @refresh="onRefreshPublication"
        @created:publication="onCreatedPublication"
      />
    </template>

    <template #footer.left>
      <v-btn
        v-if="!!viewTypeOptions.isCreate"
        depressed
        color="primary"
        @click="onAppendClick"
        v-text="'Добавить'"
      />
    </template>
  </BLayoutView>
</template>

<script>
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { createDeletableMixin } from '@/helpers/mixins/createDeletableMixin'
import { VPRPublicationModel as Model } from './Model'
import { VPRPublicationsStoreModule as StoreModule } from './store'
import { VPR_PUBLICATIONS_PAGES_ROUTES as ROUTES } from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import ComponentForm from './components/VPRPublicationsForm.vue'
import { SAVE_MENUS } from '@/components/common/BFormButtons.vue'
import { VPRPublicationsApi } from '@/api/resources'


const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)
const deletableMixin = createDeletableMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */
/** @typedef { import('@/helpers/mixins/createDeletableMixin').DeletableMixin<any, StoreModule> } Deletable */

export default {
  name: 'VPRPublicationsView',
  components: {
    BLayoutView,
    ComponentForm,
  },
  mixins: [
    viewMixin,
    deletableMixin,
  ],
  data: () => ({
    backRoute: { name: ROUTES.LIST },
    saveMenuList: Object.values(SAVE_MENUS),
    isLoadingVariants: true,
  }),
  computed: {
    createRoute() {
      return {
        name: ROUTES.CREATE,
      }
    },
    data() {
      return this.viewTypeOptions.isCreate ? void 0 : this.single
    },
    isEditable() {
      return this.$access(Permissions.edit)
    },
  },
  /** @type { View & Deletable } */
  methods: {
    ...StoreModule.mapMutations(['setOne']),
    async onSave() {
      await this.$refs.form.onSave()
    },
    onCreatedPublication(data) {
      this.setOne(data)
      const location = {
        name: ROUTES.VIEW,
        params: {
          lk_publication_id: data.lk_publication_id,
          lk_kim_storage_id: data.lk_kim_storage_id,
          lk_krit_storage_id: data.lk_krit_storage_id,
        },
      }
      this.$router.push(location)
    },
    async onRefreshPublication(vpr_publication_id) {
      this.isLoadingAsyncData = true
      try {
        const api = new VPRPublicationsApi()
        const { data } = await api.getOne(vpr_publication_id)
        this.setOne(data)
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoadingAsyncData = false
      }
    },
    onAppendClick() {
      this.$refs.form.onAppendPart()
    },
  },
}
</script>
